import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  ILoginData,
  ILoginResponse,
  ILogout,
} from "@/interface/auth.model";

export const AuthService = {
  login: async (payload: ILoginData): Promise<ILoginResponse> => {
    return callApi<ILoginResponse>(API_ENDPOINT.auth, {
      method: "POST",
      data: payload,
    });
  },

  logout: async (deviceId: string): Promise<ILogout> => {
    return callApi<ILogout>(`${API_ENDPOINT.logout}?deviceId=${deviceId}`, {
      method: "GET",
    });
  },
};
